import React, { useState, useEffect } from "react";
import CustomTable from "../../../../customComponents/CustomTable";
import searchIcon from "./../../../../../Assets/icons/searchicon.svg";
import prividegeIcon from "./../../../../../Assets/icons/priviledgeIcon.svg";
import editIcon from "./../../../../../Assets/icons/Un-Checkbox.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import { IoMdClose } from "react-icons/io";
import Loader from "../../../../customComponents/CustomLoader";
import SearchInput from "../../../../customComponents/CustomSearch/SearchInput";

const NotificationList = () => {
  const [userData, setUserData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchNotificationData(newPage);
  };

  const fetchNotificationData = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/notification/list",
        {
          orderBy: "notificationId desc",
          page,
          pageSize,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        // notificationType:item.notificationType.
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setUserData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching user list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchInputChange = (event) => {
    const serachvalue = event.target.value;
    setSearchTerm(event.target.value);
    if (serachvalue === "") {
      fetchNotificationData();
    }
  };
  const TABLE_HEADERS = [
    "Notification Type",
    "Title",
    "Value",
    // "Subject",
    "Start Date",
    "End Date",
    "Status",
    "Action",
  ];

  const keyMapping = {
    // "Sr No.": "Sr No.",

    "Notification Type": "notificationType",
    Title: "title",
    Value: "value",
    Subject: "notification_subject",
    "Start Date": "startDate",
    "End Date": "endDate",
    Status: "status",
    Action: [{ type: "edit", icon: editIcon, label: "Edit" }],
  };
  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.UPDATENOTIFICATION}`, {
      state: { data: rowData },
    });
  };
  const handleKeyPress = (e) => {
    console.log("keyname", e.key);

    if (e.key === "Enter") {
      fetchNotificationData(0, 10, searchTerm);
    }
  };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchNotificationData({ searchText: "" });
    }
  }, [searchTerm]);
  const handlePriviledges = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.UPDATENOTIFICATION}`, {
      state: { data: rowData },
    });
    console.log("rowdata", rowData);
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="OnboardManagamentContainer row">
              <div className="OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2">
                <h5>Notification Management</h5>
              </div>
              <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
                {/* <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2"> */}
                <div
                  className="topleftdataContainer"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  <h5 className="listTopDataValueText">{totalData} </h5>
                  <h6>All Notifications</h6>
                </div>
                <div
                  className="topleftdataContainer"
                  style={{ borderRight: "1px solid lightgrey" }}
                >
                  <h5 className="listTopDataValueText">{totalActive} </h5>
                  <h6>Active   Notifications</h6>
                </div>
                <div className="topleftdataContainer">
                  <h5 className="listTopDataValueText">{totalInactive} </h5>
                  <h6>Inactive Notifications</h6>
                </div>
                <div>
                  <button
                    className="addcustomerbutton"
                    onClick={() => navigate(ROUTES_NAVIGATION.SETNOTIFICATION)}
                  >
                    Set Notifications
                  </button>
                </div>
              </div>
            </div>
            <div className="tableWrapper">
              <div className="admin-list-container">
                <div className="listsearchContainer">
                  <h5>Notification Title</h5>
                  <div className="searchinput-wrapper">
                    {/* <input 
                type='text' 
                className='searchinput' 
                placeholder={`Search Notification`} 
                value={searchTerm} 
                onChange={handleSearchInputChange}
                onKeyPress={handleKeyPress} 
              />
              {searchTerm ? (
                <IoMdClose
                  size={22}
                  className="searchinput-close-icon"
                  onClick={clearSearchAndFetch}
                />
              ) : (
                <img src={searchIcon} alt="Search" className="searchinput-icon" />
              )} */}
                    <SearchInput
                      placeholder="Search Notification"
                      onSearch={fetchNotificationData}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                </div>
              </div>
              <CustomTable
                data={userData}
                headers={TABLE_HEADERS}
                keyMapping={keyMapping}
                itemsPerPage={10}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                onEdit={handleEdit}
                totalRecords={totalRecords}
                onPriviledges={handlePriviledges}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationList;
